import { render } from "./QuickView.vue?vue&type=template&id=8bd8ddc8&scoped=true"
import script from "./QuickView.vue?vue&type=script&lang=js"
export * from "./QuickView.vue?vue&type=script&lang=js"

import "./QuickView.vue?vue&type=style&index=0&id=8bd8ddc8&scoped=scoped&lang=css"
import "./QuickView.vue?vue&type=style&index=1&id=8bd8ddc8&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd8ddc8"]])

export default __exports__